module.exports = __webpack_public_path__ + "static/media/logo-ms.dbb5aa3a.svg";